import { getOrdersMeta, type OrderFilterDto } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const ORDER_LIST_META = "ORDER_LIST_META";

export function useOrdersListMeta(filter: OrderFilterDto) {
	return useQuery({
		queryKey: [
			ORDER_LIST_META,
			filter.status,
			filter.dateNextActionFrom,
			filter.dateNextActionTo,
			filter.dateStartingFrom,
			filter.dateStartingTo,
			filter.isNew,
			filter.isHasClaim,
			filter.marketId,
			filter.partnerId,
			filter.unassignedPartner,
			filter.regionId,
			filter.userId,
			filter.unassignedUser,
			filter.query,
			filter.pageLimit,
			filter.pageIndex,
			filter.isDeleted,
			filter.orderBy,
			filter.orderDirection,
			filter.review,
			filter.notReviewed,
			filter.hasExamination,
			filter.claimDateNextActionFrom,
			filter.claimDateNextActionTo,
		],
		queryFn: processResponse(() =>
			getOrdersMeta(
				filter.status ?? undefined,
				filter.dateNextActionFrom,
				filter.dateNextActionTo,
				filter.dateStartingFrom,
				filter.dateStartingTo,
				filter.isNew,
				filter.isHasClaim,
				filter.marketId,
				filter.partnerId,
				filter.unassignedPartner,
				filter.regionId,
				filter.userId,
				filter.unassignedUser,
				filter.query,
				filter.pageLimit,
				filter.pageIndex,
				filter.isDeleted,
				filter.orderBy,
				filter.orderDirection ?? undefined,
				filter.review ?? undefined,
				filter.notReviewed,
				filter.hasExamination,
				filter.claimDateNextActionFrom,
				filter.claimDateNextActionTo,
			),
		),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
	});
}
